import styled from 'styled-components';

import { useTranslation } from '@hooks';
import { ProductFeature } from '@components/products';

const ProductInfoTable = ({ details, sku }) => {
    const { t, locale } = useTranslation();
    return (
        <TableWrapper>
            {details?.map((detail) => (
                <ProductFeature
                    key={detail.id}
                    title={detail?.name[locale]}
                    feature={detail?.value[locale]}
                />
            ))}

            <ProductFeature
                title={t('barcode')}
                feature={sku}
                testId="product-barcode"
            />
        </TableWrapper>
    );
};

const TableWrapper = styled.div`
    padding: 0 15px;
`;
export default ProductInfoTable;
